// services/psa.js
import axiosInstance from './axiosInstance';

const PSA_API_URL = '/psa';

const psaService = {
  async get(adminProfile = false, idempresa = null) {
    try {
      let url;
      if (adminProfile) {
        url = `${PSA_API_URL}/get.php`;
      } else {
        url = idempresa ? 
          `${PSA_API_URL}/empresa/get.php?idempresa=${idempresa}` : 
          `${PSA_API_URL}/empresa/get.php`;
      }
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter PSA:', error);
      return [];
    }
  },

  async getById(idpsa) {
    try {
      const response = await axiosInstance.get(`${PSA_API_URL}/getById.php?idpsa=${idpsa}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter PSA por ID:', error);
      return {};
    }
  },

  async logs(idpsa) {
    try {
      const response = await axiosInstance.get(`${PSA_API_URL}/logs.php?idpsa=${idpsa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter logs PSA:', error);
      return [];
    }
  },

  async listByEmpresa(idempresa) {
    try {
      const response = await axiosInstance.get(`${PSA_API_URL}/v1/list-by-empresa.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter lista PSA por empresa:', error);
      return [];
    }
  },

  async set(psaData) {
    try {
      const response = await axiosInstance.post(`${PSA_API_URL}/set.php`, psaData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar PSA:', error);
      throw error;
    }
  },

  // Nozzles methods - /api/psa/v1/nozzle
  async getNozzles(idempresa) {
    try {
      const response = await axiosInstance.get(`${PSA_API_URL}/v1/nozzle/list.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao obter lista de nozzles:', error);
      return [];
    }
  },

  async setNozzle(nozzleData) {
    try {
      const response = await axiosInstance.post(`${PSA_API_URL}/v1/nozzle/set.php`, nozzleData);
      return response.data;
    } catch (error) {
      console.error('Erro ao associar nozzle:', error);
      throw error;
    }
  },

  async deleteNozzle(nozzleData) {
    try {
      const response = await axiosInstance.delete(`${PSA_API_URL}/v1/nozzle/set.php`, {
        data: nozzleData
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao remover associação de nozzle:', error);
      throw error;
    }
  }
};

export default psaService;
